import TablePage from '@/found/components/table_page';
import Form from './components/index';

export default {
  extends: TablePage,
  name: 'main_list',
  data() {
    return {
      requestType: 'POST',
    };
  },
  components: {
    Form,
  },
  created() {
    this.getConfigList('main_list');
  },

  methods: {
    modalClick({ val, row }) {
      console.log(val);
      const { code } = val;
      if (code === 'add' || code === 'edit' || code === 'view') {
        this.formConfig = {
          ...this.formConfig,
          code,
          row,
        };
        this.modalConfig.title = val.name || '查看';
        this.openModal();
      }
    },
  },
};
